import { Outlet } from "react-router-dom";

import "./DashboardLayout.css";
import Header from "../../../components/organisms/Header/Header";
import Sidebar from "../../../components/organisms/Sidebar/Sidebar";
import { useAppContext } from "../../../contexts/appContext";
// import Footer from "../../../components/Footer/Footer";
import logo from "../../../assets/app-logo.png";



const DashboardLayout = () => {
    const { setTheme, theme } = useAppContext();
    return (
        <div className="layout-container">
            {/* Header */}
            <Header
                onThemeToggle={setTheme}
                theme={theme}
                logo={logo}
            />

            {/* Sidebar */}
            <Sidebar />

            {/* Dynamic Content */}
            <main className="layout-main">
                <Outlet />
            </main>

            {/* Footer */}
            {/* <Footer /> */}
        </div>
    );
};

export default DashboardLayout;
